/**
 * Created by JIocb on 26.06.2017.
 */
namespace Factive.Core {

    export class EventBusConstants {
        public static TOPIC_UI:string = "eventbus.topic_ui";
        public static EVENT_COLOR_BONUS_PANEL_PRESS_YES:string = "eventbus.COLOR_BONUS_PANEL_PRESS_YES";
        public static EVENT_COLOR_BONUS_PANEL_PRESS_NO:string = "eventbus.COLOR_BONUS_PANEL_PRESS_NO";
        public static EVENT_ACHIEVEMENT_PANEL_REQUESTS_TO_CLOSE:string = "eventbus.ACHIEVEMENT_PANEL_REQUESTS_TO_CLOSE";
        public static EVENT_HELP_PANEL_REQUESTS_TO_CLOSE:string = "eventbus.EVENT_HELP_PANEL_REQUESTS_TO_CLOSE";
        public static EVENT_GAME_END_PANEL_PRESS_OK:string = "eventbus.EVENT_GAME_END_PANEL_PRESS_OK";

        public static EVENT_ARE_YOU_SURE_PANEL_PRESS_YES:string = "eventbus.EVENT_ARE_YOU_SURE_PANEL_PRESS_YES";
        public static EVENT_ARE_YOU_SURE_PANEL_PRESS_NO:string = "eventbus.EVENT_ARE_YOU_SURE_PANEL_PRESS_NO";




        public static GAMEPLAY:string = "eventbus.gameplay";
        public static GAMEPLAY_GAME_EVENT_CHANGED:string = "eventbus.GAMEPLAY_GAME_EVENT_CHANGED";
        public static GAMEPLAY_GAME_STARTED:string = "eventbus.GAMEPLAY_GAME_STARTED";
        public static GAMEPLAY_GAME_ENDED:string = "eventbus.GAMEPLAY_GAME_ENDED";
        public static GAMEPLAY_MIDROLL_REQUESTED:string = "eventbus.GAMEPLAY_MIDROLL_REQUESTED";
        public static GAMEPLAY_MIDROLL_STARTED:string = "eventbus.GAMEPLAY_MIDROLL_STARTED";
        public static GAMEPLAY_MIDROLL_FINISHED:string = "eventbus.GAMEPLAY_MIDROLL_FINISHED";
        public static GAMEPLAY_ACTIVATE_COLOR_BONUS:string = "eventbus.GAMEPLAY_ACTIVATE_COLOR_BONUS";
        public static EVENT_SETTINGS_PANEL_PRESS_QUIT: string = "eventbus.EVENT_SETTINGS_PANEL_PRESS_QUIT";
        public static EVENT_SETTINGS_PANEL_PRESS_HELP: string = "eventbus.EVENT_SETTINGS_PANEL_PRESS_HELP";
        public static EVENT_SETTINGS_PANEL_PRESS_CLOSE: string = "eventbus.EVENT_SETTINGS_PANEL_PRESS_CLOSE";
    }
}


// WEBPACK FOOTER //
// src/typescript/Core/Event/EventBusConstants.ts